module.exports = __webpack_public_path__ + "img/logo-mini.5612a9e.svg";